module.exports = __webpack_public_path__ + "img/pro_beijia_02.df21888d.jpg";